import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContratarPolizaComponent } from '../../components/contratar-poliza/contratar-poliza.component';

@Component({
	standalone: true,
	imports: [
		CommonModule,
		ContratarPolizaComponent
	],
	templateUrl: './contratar-poliza.view.html',
	styleUrls: ['./contratar-poliza.view.scss'],
	host: {
		'data-view-id': 'contratar-poliza-view'
	}
})
export class ContratarPolizaView {}
